
function requireAll(req) {
    req.keys().forEach(req)
}

requireAll(require.context("../src/app/", true, /\.html$/))
